module.exports = __webpack_public_path__ + "img/appstore.bdf6423e.svg";